export default function formatStorageSize(bytes = 0) {
    const mb = bytes / 1024 / 1024
    if (mb < 1024) return `${Math.round(mb)} MB`
    if (mb < 1000000) return `${(mb / 1024).toFixed(1)} GB`
    if (mb < 1000000000) return `${(mb / 1024 / 1024).toFixed(1)} TB`
}